import type { TeamListItem } from "../types/teams.types";

export const filterTeamsBySearch = (teams: readonly TeamListItem[], searchTerm: string): TeamListItem[] => {
    const trimmedSearch = searchTerm.trim().toLowerCase();

    if (!trimmedSearch) {
        return [...teams];
    }

    return teams.filter((team) =>
        [team.name ?? "", team.description ?? ""].some((value) => value.toLowerCase().includes(trimmedSearch)),
    );
};
